import { motion } from "motion/react";
import { RippleButton } from "./ripple-button";
import logo from "@/assets/quantum-mind-brain.png.asset.json";
import { BrandWordmark } from "./brand-wordmark";

export function WelcomeScreen({ onStart }: { onStart: () => void }) {
  return (
    <div className="aurora relative flex min-h-[100dvh] flex-col items-center justify-between overflow-hidden px-7 pb-12 pt-24">
      <motion.div
        aria-hidden
        className="pointer-events-none absolute left-1/2 top-[22%] size-[420px] -translate-x-1/2 rounded-full blur-3xl"
        style={{ backgroundImage: "var(--gradient-brand)", opacity: 0.25 }}
        initial={{ scale: 0.6, opacity: 0 }}
        animate={{ scale: 1, opacity: 0.25 }}
        transition={{ duration: 1.4, ease: "easeOut" }}
      />

      <div className="flex flex-1 flex-col items-center justify-center text-center">
        <motion.div
          initial={{ scale: 0.7, opacity: 0, filter: "blur(14px)" }}
          animate={{ scale: 1, opacity: 1, filter: "blur(0px)" }}
          transition={{ type: "spring", stiffness: 140, damping: 16 }}
          className="relative"
        >
          <img
            src={logo.url}
            alt="The Quantum MIND logo"
            width={128}
            height={128}
            decoding="async"
            fetchPriority="high"
            className="size-32 object-contain drop-shadow-[0_0_38px_rgba(120,90,255,0.5)]"
          />
        </motion.div>

        <motion.h1
          initial={{ y: 24, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.35, duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
          className="mt-9"
        >
          <BrandWordmark size="lg" />
        </motion.h1>

        <motion.p
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.55, duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
          className="mt-3 text-base text-muted-foreground"
        >
          Build Consistency. Crack JEE.
        </motion.p>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.9, duration: 0.8 }}
          className="mt-10 flex flex-wrap items-center justify-center gap-2 text-xs text-muted-foreground"
        >
          {["Focus Timer", "Streaks & XP", "Smart Revision"].map((tag) => (
            <span key={tag} className="glass rounded-full px-3 py-1.5">
              {tag}
            </span>
          ))}
        </motion.div>
      </div>

      <motion.div
        initial={{ y: 40, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ delay: 1.05, type: "spring", stiffness: 120, damping: 18 }}
        className="w-full"
      >
        <RippleButton size="lg" className="w-full" onClick={onStart}>
          🚀 Start Your Journey
        </RippleButton>
      </motion.div>
    </div>
  );
}